import React from 'react';
import {withTranslation} from 'react-i18next';
import findDayEntity, {openingHoursStringFromEntity} from '../calendar/calendar-context';

const OpeningHours = (props) => {
  let today = new Date();
  let todayEntity = findDayEntity(today);

  return (
    <div>{props.t(openingHoursStringFromEntity(todayEntity))}</div>
  );
}

export default withTranslation()(OpeningHours);
